import { SegmentStation } from "./SegmentStation"
import { SegmentLineItems } from "./SegmentLineItems";
import { SegmentType } from "./SegmentType";
import { GuidUtility } from "../../../common/GuidUtility";

export class SegmentItem {

	constructor() {

		this.id=null;
		this.itemType = null;
		this.itemTypeDesc=null;
		this.lines = new SegmentLineItems();
		this.stationEnd = null;
		this.stationStart = null;

		this.stationEndName=null;
		this.stationStartName=null;
		this.segmentDescInfo=new SegmentDescInfo();

		this.stationCount=0;
		this.stationCountDesc="";

		this.crsCode="EPSG:4326";


	}

	isBusType()
	{	
		if(this.itemType===SegmentType.Bus)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	isSubwayType()
	{	
		if(this.itemType===SegmentType.Subway
			|| this.itemType===SegmentType.TransferInSubway)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	/**
	 * 是否为公共交通
	 */
	isTransport()
	{
		if(this.itemType===SegmentType.Bus||this.itemType===SegmentType.Subway
			|| this.itemType===SegmentType.TransferInSubway)
		{
			return true;
		}
		else
		{
			return false;
		}
	}

	/**
	 * 设置起点站名称
	 * @param {*} stationName 
	 */
	setStationStartName(stationName)
	{	
		this.stationStartName=stationName;

		if(this.stationStart)
		{
			this.stationStart.name=stationName;
		}
	}	

	/**
	 * 设置终点站名称
	 * @param {*} stationName 
	 */
	setStationEndName(stationName)
	{	
		this.stationEndName=stationName;

		if(this.stationEnd)
		{
			this.stationEnd.name=stationName;
		}
	}	

	/**
	 * 重置线段描述
	 */
	resetSegmentDesc()
	{
		this.segmentDescInfo = this._getSegmentDescInfo();
	}


	static GetSegmentItem(jsonItem) {
		let curItem = null;
		if (jsonItem == null) return curItem;

		curItem = new SegmentItem();
		curItem.id=GuidUtility.getGuid();
		curItem.itemType = jsonItem.segmentType;
		curItem.itemTypeDesc=SegmentType.getTypeDescription(curItem.itemType);
		curItem.stationStart = SegmentStation.GetSegmentStation(jsonItem.stationStart);
		curItem.stationEnd = SegmentStation.GetSegmentStation(jsonItem.stationEnd);
		curItem.lines = SegmentLineItems.GetSegmentLineItems(jsonItem.segmentLine);
		curItem.segmentDescInfo=curItem._getSegmentDescInfo();
		curItem.stationCount=curItem.lines.getStationCount();
		if(curItem.stationCount && curItem.stationCount>0)
		{
			curItem.stationCountDesc=curItem.stationCount +"站";
		}


		if(curItem.stationStart)
		{	
			curItem.stationStart.segmentItem=curItem;
			curItem.stationStartName=curItem.stationStart.name;
		}

		if(curItem.stationEnd)
		{	
			curItem.stationEnd.segmentItem=curItem;
			curItem.stationEndName=curItem.stationEnd.name;
		}


		return curItem;
	}

	/**
	 * 获取描述
	 */
	_getSegmentDescInfo() {
		let descInfo=new SegmentDescInfo();

		let segmentDesc = null;
		let prefixDesc=null;
		let suffixDesc=null;

		let startName = this.stationStart.name;
		let endName = this.stationEnd.name;
		let linesDesc = this.lines.getLinesDescription();

		let segmentTypeDesc = SegmentType.getTypeDescription(this.itemType);



		if (this.itemType === SegmentType.Walk) {
			prefixDesc= "从" + startName + segmentTypeDesc + "至";
			suffixDesc="";
		}
		else if (this.itemType === SegmentType.Bus) {
			prefixDesc=segmentTypeDesc + linesDesc + " 在" ;
			suffixDesc="下车";
		}
		else if (this.itemType === SegmentType.Subway) {
			prefixDesc=segmentTypeDesc + linesDesc + " 在" ;
			suffixDesc="下车";
		}
		else if (this.itemType === SegmentType.TransferInSubway) {
			prefixDesc=segmentTypeDesc;
			suffixDesc="";
		}

		segmentDesc=prefixDesc + endName + suffixDesc;
		descInfo.prefixDesc=prefixDesc;
		descInfo.suffixDesc=suffixDesc;
		descInfo.endName=endName;
		descInfo.description=segmentDesc;

		return descInfo;
	}

}//end SegmentItem

export class SegmentDescInfo
{	
	constructor()
	{	
		this.description=null;
		this.prefixDesc=null;
		this.endName=null;
		this.suffixDesc=null;
	}





}
